$.module('MM.errors', function () {
  var API = {
    30301: '用户名或密码不正确',
    30302: '用户名或密码不正确',
    30307: '昵称重复',
    30308: '此邮箱已被注册',
    33010: '主播专属礼物，无法送给其他主播',
    30312: '用户名不存在',
    30405: '身份已经过期',
    30412: '余额不足，请充值',
    30413: '权限不足',
    30415: '房间已关闭直播',
    30416: '因您直播室出现违规行为，现在处于禁播状态，15分钟后方可正常直播',
    30417: '任务还未完成，无法领取柠檬',
    30418: '您的帐号已被冻结，请联系客服',
    30419: '验证码验证失败',
    30421: '您的帐号已被冻结，请联系客服',
    30422: 'VIP特权，请购买VIP',
    30423: '注册过于频繁，请稍后注册',
    30424: '已被抢光，明天早点来',
    30428: '仅M特权专享',
    30444: '您还没有验证邮箱',
    30451: '包含敏感词',
    80001: '今日头像更换次数已达上限，请明日再试',
    80101: '今日修改昵称次数已达上限，请明日再试',
    97685: '设备暂时无法使用!',
    97686: '设备使用中，请稍后!',
    97684: '暂时不支持同时送多个喷喷!',
    97683: '主播已下线，敬请期待!',
  };

  var API_ERROR_HANDLERS = {
    30405: function () {
      // if($.store.get('REFRESH_TOKEN')){
      //     MM.user.refreshToken.refresh();
      // } else {
      MM.user.expired();
      // }
    },
    30412: function () {
      MM.common.showNoMoney();
    },
    30418: function (result) {
      var fn = function () {
        MM.user.clearUserInfo();

        location.reload();
      };

      if (result.unfreeze_time) {
        MM.ui.messager.warn(
          '您因涉嫌违规而被系统冻结账号，将于' +
            MM.common.formatTime(
              new Date(result.unfreeze_time),
              'yyyy年MM月dd日',
            ) +
            '解封，如有问题请到 App 内申诉',
          fn,
        );
      } else {
        MM.ui.messager.warn(
          '您因涉嫌违规而被系统冻结账号，如有问题请到 App 内申诉',
          fn,
        );
      }
    },
    30421: function (result) {
      MM.ui.messager.warn(result.msg, MM.user.logout);
    },
    30428: function () {
      MM.ui.popup.showConfirm(
        'M特权',
        '<p style="line-height:60px;">此礼物仅M特权专享</p>',
        function () {
          window.open('/privilege/m', 'blank');
        },
        function () {
          window.open('/privilege/m', 'blank');
        },
        '了解详情',
      );
    },
    30451: function () {
      MM.ui.messager.warn('内容包含敏感词');
    },
  };

  var CRYOLITE = {
    1500: '房间不存在',
    1501: '此主播为灰名单主播，无法推荐',
    1800: '用户无效',
    1801: '推荐次数不足',
    1802: '推荐队列已满，请稍后再试',
    1803: '当前主播正在推荐队列中，请稍后再试',
    1804: '当前主播不符合推荐等级要求',
    1805: '主播无法被推荐',
  };

  // 所有错误提示和处理方法的汇总集合
  var ALL_ERRORS = {
    api: {
      msgs: API,
      // msgs : _.assign(API, CRYOLITE, cryolite),
      handlers: API_ERROR_HANDLERS,
    },
    cryolite: {
      msgs: CRYOLITE,
    },
  };

  var allHandlers = {
    6805: function (res) {
      MM.ui.popup.showConfirm(
        '温馨提示',
        res.msg,
        function () {
          request.post({
            url: '/api/v1/mystic/status',
            urlType: 'cryolite',
            contentType: 'FORM_URL',
            success: function (res) {
              MM.ui.messager.success('已切换', function () {
                MM.user.getExtraUserInfo(function () {
                  location.reload();
                });
              });
            },
          });
        },
        null,
        '切回原身',
        '取消',
      );
    },
  };

  /**
   * 自定义添加额外的错误处理
   * @param {String} type 错误所属接口类型
   * @param {Object} msgs 不同code码对应的错误提示
   * @param {Object} handlers 一个function object 对应不同code的回调参数
   */
  function addErrors(type, msgs, handlers) {
    ALL_ERRORS[type] = _.merge(ALL_ERRORS[type], {
      msgs: msgs || {},
      handlers: handlers || {},
    });
  }

  /**
   * 判断请求是否正常，没有特殊状态码，
   * 如果有非1以外的code码，则进行处理并添加对应的错误信息
   * @param  {Object} result 请求结果
   * @param  {Function} callback 额外的处理错误方法
   */
  function _handleError(res, type, callback) {
    type = type || 'api';

    var currErrorData = ALL_ERRORS[type] || {};
    var handlers = currErrorData.handlers;
    var msgs = currErrorData.msgs || {};
    var code = res.code;
    var msg = res.message || res.msg || msgs[code];
    res.msg = res.message = msg;
    // var msg = res.msg || msgs[code] || '请求出错，请稍后访问！';

    //|| res.message || res.msg || '请求出错，请稍后访问！'

    if (handlers && handlers[code]) {
      handlers[code](res);
      return; // handler 权重更高 直接return
    } else if (allHandlers[code]) {
      allHandlers[code](res);
      return;
    } else if (msg) {
      res.message = msg;

      if (!callback) {
        MM.ui.messager.warn(msg);
      }
    }

    callback && callback(res);
  }

  return {
    handleError: _handleError,
    addErrors: addErrors,
  };
});
